import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_CLAIM_QUOTE = graphql(`
  query getClaimQuoteQuery($uuid: String) {
    quotes(filters: { claimUuid: $uuid }) {
      edges {
        node {
          uuid
          endorsements(filters: { included: true }) {
            edges {
              node {
                uuid
                name
                reserveTypes {
                  edges {
                    node {
                      uuid
                      name
                    }
                  }
                }
              }
            }
          }
          coverages(filters: { included: true }) {
            edges {
              node {
                uuid
                name
                reserveTypes {
                  edges {
                    node {
                      uuid
                      name
                    }
                  }
                }
                subCoverages(filters: { included: true }) {
                  edges {
                    node {
                      uuid
                      name
                      reserveTypes {
                        edges {
                          node {
                            uuid
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
export interface IUseClaimQuoteQueryArg {
  claimUuid?: string;
}
export function useClaimQuoteQuery({ claimUuid }: IUseClaimQuoteQueryArg) {
  const { loading, data, error } = useQuery(GET_CLAIM_QUOTE, {
    variables: {
      uuid: claimUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
